<script lang="ts">
  import Icon from "../../common/icons/Icon.svelte";
  import { applyContactEmail } from "../../../app/store/store-careers";
  import ClipboardJS from "clipboard";
  import tooltipAction, {
    TooltipPostionType,
    TooltipOptions,
  } from "../../../components/common/tooltip/index";
  import { onMount } from "svelte";

  let copyButtonElement: HTMLElement;
  let clipboard: ClipboardJS;
  let tooltipPosition: TooltipPostionType = "bottom";
  let tooltipOptions: TooltipOptions;
  let tooltipContent: string = "Copy";
  let disabledTooltip: boolean = true;
  let removeTooltipTimeout = null;
  const showCopiedTooltipDuration = 1400;

  onMount(() => {
    clipboard = new ClipboardJS(copyButtonElement);

    clipboard.on("success", function (e) {
      if (removeTooltipTimeout) {
        clearTimeout(removeTooltipTimeout);
        removeTooltipTimeout = null;
      }

      tooltipContent = "Copied";
      disabledTooltip = false;

      removeTooltipTimeout = setTimeout(() => {
        disabledTooltip = true;
        removeTooltipTimeout = null;
      }, showCopiedTooltipDuration);
    });

    return () => {
      clipboard.destroy();
    };
  });

  function handleButtonMouseEnter() {
    if (removeTooltipTimeout) {
      clearTimeout(removeTooltipTimeout);
      removeTooltipTimeout = null;
    }

    tooltipContent = "Copy";
    disabledTooltip = false;
  }

  function handleButtonMouseLeave() {
    if (!removeTooltipTimeout) {
      disabledTooltip = true;
    }

  }

  $: tooltipOptions = {
    auto: true,
    content: tooltipContent,
    disabled: disabledTooltip,
    position: tooltipPosition,
    fadeOutAnimation: true,
  };
</script>

<div class="apply-contact">
  <div>{applyContactEmail}</div>
  <button
    data-clipboard-text={applyContactEmail}
    bind:this={copyButtonElement}
    use:tooltipAction={tooltipOptions}
    on:mouseenter={handleButtonMouseEnter}
    on:mouseleave={handleButtonMouseLeave}
  >
    <Icon icon="copy" size="24px" />
  </button>
</div>

<style lang="postcss">
  .apply-contact {
    @apply relative flex flex-row items-center mr-auto rounded text-pink-100 font-medium bg-white;
    padding: 0px 0px 0px 20px;
    max-width: fit-content;
    box-shadow: 1px 3px 10px rgba(55, 84, 170, 0.1);
    font-size: 15px;
    line-height: 1.7;
    gap: 54px;
  }

  button {
    @apply flex flex-row items-center justify-center bg-light-50 text-dark-50 cursor-pointer;
    border: none;
    width: 42px;
    height: 46px;
    border-radius: 0px 4px 4px 0px;
  }

  button:hover,
  button:active {
    @apply text-dark-300;
  }
</style>
